import i18n from '@/utils/i18n';
import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import {
  PHONE_BAR_WIDTH,
  SUBTITLE_BAR_HEIGHT,
} from '@/experiences/sales-portal/domain/prospects/screens/prospect-detail/constants';
import { Typography } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

interface ProspectDetailPhoneNumberProps {
  isLoading: boolean;
  phoneNumber: string | null;
}

export const ProspectDetailPhoneNumber: React.FC<
  ProspectDetailPhoneNumberProps
> = ({ isLoading, phoneNumber }) => {
  const theme = useTheme();

  if (isLoading) {
    return (
      <AnimatedSkeletonLoader
        borderRadius={theme.sk.radii.radiusRound}
        height={SUBTITLE_BAR_HEIGHT}
        width={PHONE_BAR_WIDTH}
      />
    );
  }

  if (!phoneNumber) {
    return null;
  }

  return (
    <Typography
      accessibilityLabel={i18n.t('phone_number')}
      color="$textSecondary"
      size="$sm"
      variant="body"
    >
      {phoneNumber}
    </Typography>
  );
};
